import { atom } from "jotai";

export interface IVendor {
    id?: string;
    brand_name: string;
    email?: string | null;
    phone?: string | null;
    website?: string | null;
    primary_contact?: string | null;
    created_at?: string;
    updated_at?: string;
}

export interface IVendorInput extends Omit<IVendor, 'id' | 'created_at' | 'updated_at'> {}

export const vendorsAtom = atom<IVendor[]>([]);
export const vendorsLoadingAtom = atom<boolean>(false);

